import Tabs from './components/tabs'

$(document).ready(function () {
  if($('.actualite').length > 0) {
    new Tabs();
  }
});